export const PUSH_NOTIFICATION_KEY          = 'push_notifications';
export const PUSH_NOTIFICATIONS_SUBSCRIBED  = 'subscribed'
export const PUSH_NOTIFICATIONS_REJECTED    = 'rejected'
export const PUSH_NOTIFICATIONS_DELAYED     = 'delayed'